<template>
  <div>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <v-sheet>
      <v-form class="main-form pa-3" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                placeholder=" "
                :label="$t('Name')"
                v-model="admin.name"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                placeholder=" "
                :label="$t('LastName')"
                v-model="admin.lastName"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex flex-row justify-end">
            <v-btn
              depressed
              tile
              class="text-capitalize white--text ml-5"
              color="primary"
              width="100"
              :loading="editing"
              @click="editAdmin()"
            >
              <img
                class="mr-1"
                width="20px"
                height="20px"
                src="/icons/edit-white.svg"
              />
              {{ $t("Edit") }}
            </v-btn>
          </div>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceAdmin from "@/api/apiAdminService";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { AdminRoles } from "@/models/AdminRolesEnum";
export default {
  name: "NewAccount",
  props: {
    adminProp: Object
  },
  components: {},
  data() {
    return {
      roles: AdminRoles,
      editing: false,
      errorMsg: "",
      errorAlert: false,
      admin: {
        _id: "",
        name: "",
        lastName: "",
        phone: "",
        email: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        }
      }
    };
  },
  watch: {
    adminProp: {
      handler() {
        this.admin = Object.assign({}, this.adminProp);
      },
      deep: true
    }
  },
  methods: {
    editAdmin() {
      if (this.$refs.form.validate()) {
        this.editing = true;
        console.log(this.admin.user);
        RestResourceAdmin.prototype
          .putAdmin(this.admin._id, {
            name: this.admin.name,
            lastName: this.admin.lastName
          })
          .then(response => {
            if (response && response.status == ResponseStatus.OK) {
              this.$router.push({ name: "admins_accounts" });
            }
            this.editing = false;
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.editing = false;
          });
      }
    }
  }
};
</script>
<style></style>
